import { Space, Select } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '@/i18n';
import { DashboardCard } from '@/presentation/components/dashboard-card';

export interface DashboardHeaderProps {
  onChange?: (deviceType: DeviceType) => void;
}

export enum DeviceType {
  All = '',
  Simulator = 'simulator',
  Device = 'device'
}


export const DEVICE_TYPE_OPTIONS = [
  { label: i18n.t('真机+模拟器'), value: DeviceType.All },
  { label: i18n.t('真机'), value: DeviceType.Device },
  { label: i18n.t('模拟器'), value: DeviceType.Simulator },
];

export const DashboardHeader: FC<DashboardHeaderProps> = (props) => {
  const { t } = useTranslation();
  const {} = props;

  return (
    <DashboardCard title={''}>
      <Space className={'reset-form'}>
        <Space direction={'vertical'}>
          <span style={{ fontSize: 12 }}>{t('设备类型')}</span>
          <Select
            options={DEVICE_TYPE_OPTIONS}
            style={{ width: 208 }}
            defaultValue={DeviceType.All}
            onChange={props.onChange}
          />
        </Space>
      </Space>
    </DashboardCard>
  );
};
